import * as React from "react";
import classnames from "classnames";
import { useIntersectionObserver } from "@grandvisionhq/lib-utils-react";
function withLazyLoading(Component, options) {
  const {
    rootMargin = "150px 0px",
    className,
    classNameAfterLoad = "",
    classNameBeforeLoad = "",
    ["data-t"]: dataT
  } = options || {};
  const wrappedName = Component.displayName || Component.name || "Component";
  const withLazyLoading2 = (props) => {
    const [inViewRef, inView] = useIntersectionObserver({
      rootMargin,
      freezeOnceVisible: true
    });
    const containerClassName = classnames("lazy-loading", className, [
      {
        [`${classNameBeforeLoad}`]: !inView,
        [`${classNameAfterLoad}`]: inView
      }
    ]);
    return /* @__PURE__ */ React.createElement("div", { className: containerClassName, ref: inViewRef, "data-t": dataT }, inView ? /* @__PURE__ */ React.createElement(Component, { ...props }) : null);
  };
  withLazyLoading2.displayName = `WithLazyLoading(${wrappedName})`;
  return withLazyLoading2;
}
export {
  withLazyLoading
};
//# sourceMappingURL=with-lazy-loading.js.map
